
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import GTag from '../components/GTag';
function Punetoalandidehu() {



    const cardData =
    {
        keyword: 'Pune To Alandi - Dehu Darshan Cab',
        heading: 'Mauli Cabs: Pune To Alandi - Dehu Darshan Cab',
        headingDescription: 'Mauli Cabs offers comfortable and reliable Pune to Alandi - Dehu Darshan cab services, ensuring a smooth and spiritual journey to these sacred pilgrimage sites. Whether you are visiting for a religious trip or a peaceful retreat, we provide a variety of vehicles including sedans, SUVs, and premium cars to match your needs. With professional drivers, transparent pricing, no hidden charges, and a commitment to safety, Mauli Cabs guarantees a hassle-free and enriching ride from Pune to Alandi and Dehu.',

        top: 'Top Places to Visit in Alandi with Mauli Cabs',

"topPlaces": [
    {
        "title": "Sant Dnyaneshwar Samadhi Mandir",
        "description": "The final resting place of the revered saint and poet Sant Dnyaneshwar, this temple is the spiritual heart of Alandi. Pilgrims from across Maharashtra visit to pay homage and participate in the vibrant Ekadashi celebrations."
    },
    {
        "title": "Indrayani River Ghats",
        "description": "The ghats along the Indrayani River are sacred bathing spots for devotees. The serene atmosphere and spiritual significance make it a peaceful place for reflection and rituals."
    },
    {
        "title": "Jalaram Temple",
        "description": "Dedicated to Saint Jalaram, this temple is known for its architectural beauty and the peaceful ambiance it offers to visitors seeking solace."
    },
    {
        "title": "Tukaram Maharaj Samadhi Mandir",
        "description": "Located in nearby Dehu, this temple marks the final resting place of Sant Tukaram. It's an important site for devotees following the Varkari tradition."
    },
    {
        "title": "Khandoba Temple",
        "description": "A historic temple dedicated to Lord Khandoba, this site is known for its vibrant festivals and cultural significance in the region."
    },
    {
        "title": "Vitthal-Rakhumai Temple",
        "description": "Situated in the vicinity, this temple is dedicated to Lord Vitthal and Goddess Rakhumai. It's a prominent place of worship for devotees."
    },
    {
        "title": "Lakshmi Narayan Mandir",
        "description": "An ancient temple dedicated to Lord Vishnu and Goddess Lakshmi, known for its serene environment and architectural elegance."
    },
    {
        "title": "Pundalik Mandir",
        "description": "A revered temple dedicated to Lord Pundalik, this site attracts devotees seeking blessings and spiritual solace."
    },
    {
        "title": "Siddhabet",
        "description": "A sacred site where Sant Dnyaneshwar completed his commentary on the Bhagavad Gita, offering a tranquil environment for reflection."
    },
    {
        "title": "Changdev Bhinta",
        "description": "A historical site associated with the saint Changdev, known for its spiritual significance and peaceful surroundings."
    }
],

"services": [
    {
        "name": "Pune to Alandi - Dehu Darshan Cab Service",
        "description": "Mauli Cabs offers comfortable and reliable taxi services for your pilgrimage journey from Pune to Alandi and Dehu. Experience a smooth and safe ride to these spiritual destinations."
    },
    {
        "name": "Book Pune to Alandi - Dehu Darshan Taxi",
        "description": "Book your taxi from Pune to Alandi and Dehu Darshan with Mauli Cabs for a hassle-free and peaceful pilgrimage. Our well-maintained cabs ensure a comfortable and safe journey."
    },
    {
        "name": "Affordable Pune to Alandi - Dehu Darshan Cab",
        "description": "Mauli Cabs provides affordable and budget-friendly taxi services from Pune to Alandi and Dehu Darshan. Travel comfortably without compromising on quality."
    },
    {
        "name": "Private Taxi for Alandi - Dehu Darshan from Pune",
        "description": "Choose a private taxi service from Pune to Alandi and Dehu Darshan with Mauli Cabs. Enjoy the convenience of a personalized ride with professional drivers for a peaceful journey."
    },
    {
        "name": "Alandi - Dehu Pilgrimage Tour from Pune",
        "description": "Mauli Cabs offers a dedicated pilgrimage tour service for Alandi and Dehu from Pune. Our experienced drivers will ensure a comfortable and smooth journey for your spiritual visit."
    },
    {
        "name": "Pune to Alandi - Dehu One-Way or Round Trip",
        "description": "Mauli Cabs offers both one-way and round-trip services from Pune to Alandi and Dehu. Choose the best option to suit your schedule and enjoy a comfortable ride."
    },
    {
        "name": "Comfortable Taxi Ride to Alandi - Dehu",
        "description": "Enjoy a comfortable and peaceful taxi ride from Pune to Alandi and Dehu with Mauli Cabs. Our vehicles are well-maintained to ensure a smooth journey for all passengers."
    },
    {
        "name": "Group Travel to Alandi - Dehu",
        "description": "Travel with your group from Pune to Alandi and Dehu in comfort and style. Mauli Cabs offers spacious vehicles to ensure that everyone travels together with ease."
    },
    {
        "name": "Luxury Cab for Alandi - Dehu Darshan",
        "description": "Experience luxury while traveling from Pune to Alandi and Dehu with Mauli Cabs. Choose from our premium vehicles for a comfortable and indulgent pilgrimage journey."
    }
],

"tableData": [
    ["Pune to Alandi - Dehu Darshan Cab Service", "Book Pune to Alandi - Dehu Darshan Taxi"],
    ["Affordable Pune to Alandi - Dehu Darshan Cab", "Private Taxi for Alandi - Dehu Darshan from Pune"],
    ["Alandi - Dehu Pilgrimage Tour from Pune", "Pune to Alandi - Dehu One-Way or Round Trip"],
    ["Comfortable Taxi Ride to Alandi - Dehu", "Group Travel to Alandi - Dehu"],
    ["Luxury Cab for Alandi - Dehu Darshan", ""]
],


"whychoose": [
    {
        "WhyChooseheading": "Reliable and Timely Service",
        "WhyChoosedescription": "Mauli Cabs ensures reliable and timely service for your Pune to Alandi - Dehu Darshan Cab journey. Our professional drivers are committed to providing punctual pickups and drop-offs, so you can fully immerse yourself in the spiritual experience without worrying about time."
    },
    {
        "WhyChooseheading": "Comfortable and Spacious Vehicles",
        "WhyChoosedescription": "For your Pune to Alandi - Dehu Darshan trip, we offer a range of comfortable vehicles, including sedans, SUVs, and premium cars. All our vehicles are air-conditioned, spacious, and well-maintained, ensuring a smooth and comfortable journey as you visit these holy places."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Our experienced and professional drivers are familiar with the best routes to Alandi and Dehu. They ensure a safe, smooth, and timely journey, so you can focus on your spiritual darshan without any stress or distractions."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Mauli Cabs offers affordable and transparent pricing for your Pune to Alandi - Dehu Darshan Cab. We provide upfront, clear pricing with no hidden charges, ensuring you get the best value for your money while visiting these religious landmarks."
    },
    {
        "WhyChooseheading": "Safe and Comfortable Journey",
        "WhyChoosedescription": "Your safety is our top priority. All our vehicles are regularly serviced and equipped with modern safety features like airbags, seat belts, and GPS tracking. Our drivers strictly adhere to safety protocols, ensuring your peace of mind during your pilgrimage."
    },
    {
        "WhyChooseheading": "24/7 Availability",
        "WhyChoosedescription": "Mauli Cabs is available 24/7 for your Pune to Alandi - Dehu Darshan trip. Whether you're planning an early morning visit or a late-night return, our customer service team is always available to assist you with your booking at any time."
    },
    {
        "WhyChooseheading": "Easy and Hassle-Free Booking",
        "WhyChoosedescription": "Booking your Pune to Alandi - Dehu Darshan cab with Mauli Cabs is quick and easy. You can book online via our website or mobile app, or contact our customer service team for personalized assistance and a smooth booking experience."
    },
    {
        "WhyChooseheading": "Customized Travel Packages",
        "WhyChoosedescription": "Mauli Cabs offers customized travel packages for your Pune to Alandi - Dehu Darshan trip. Whether you're visiting for a religious pilgrimage or seeking a peaceful retreat, we can tailor your journey to suit your needs and preferences."
    }
]





















    }



    const faqData = [
        {
            question: 'How do I book a cab from Pune to Alandi - Dehu for Darshan with Mauli Cabs?',
            answer: 'Booking your cab for a Darshan trip from Pune to Alandi and Dehu is easy! You can book directly through our website or mobile app. Just enter Pune as your pickup location and Alandi or Dehu as your destination, then choose the vehicle that suits your needs. Alternatively, you can call our customer support team for assistance.',
        },
        {
            question: 'What types of cabs are available for the Pune to Alandi - Dehu Darshan trip?',
            answer: 'Mauli Cabs offers a variety of vehicles for your Darshan trip to Alandi and Dehu, including Sedans, SUVs, Ertiga, Innova Crysta, and premium options. You can select a vehicle based on your group size, comfort preferences, and budget.',
        },
        {
            question: 'Is the fare for the Pune to Alandi - Dehu Darshan trip fixed?',
            answer: 'Yes, the fare for the trip is fixed and transparent. It includes tolls, taxes, and driver charges, with no hidden costs. The total fare is provided upfront before confirming your booking.',
        },
        {
            question: 'How long does the journey from Pune to Alandi - Dehu take?',
            answer: 'The journey from Pune to Alandi and Dehu typically takes around 1 to 1.5 hours, depending on traffic conditions. Our drivers ensure a smooth and timely journey to both places of worship.',
        },
        {
            question: 'Are the drivers experienced with the Pune to Alandi - Dehu route?',
            answer: 'Yes, Mauli Cabs drivers are experienced with the Pune to Alandi - Dehu route and are familiar with the best roads to ensure a safe and timely journey. They prioritize your comfort and safety throughout the Darshan trip.',
        },
        {
            question: 'Can I book a round trip for the Pune to Alandi - Dehu Darshan?',
            answer: 'Yes, you can easily book a round trip to both Alandi and Dehu. Just provide your return details when making the booking, and we will ensure a smooth return journey back to Pune after your Darshan.',
        },
        {
            question: 'Can I make stops at other temples or sights during the trip?',
            answer: 'Yes, you can customize your trip by making stops for other temples or sights along the way. If you wish to visit other attractions around Alandi or Dehu, just let our driver know, and they will accommodate your requests.',
        },
        {
            question: 'Are the cabs air-conditioned and comfortable?',
            answer: 'Yes, all our cabs are fully air-conditioned and well-maintained for cleanliness and comfort. We prioritize your comfort and ensure a pleasant ride to Alandi and Dehu.',
        },
        {
            question: 'Can I cancel or modify my booking after confirmation?',
            answer: 'Yes, you can cancel or modify your booking. We offer a flexible cancellation policy through our website or app, and our customer support team is always available to assist you.',
        },
        {
            question: 'Why should I choose Mauli Cabs for my Pune to Alandi - Dehu Darshan trip?',
            answer: 'Mauli Cabs offers reliable and professional service, competitive pricing, a wide range of vehicle options, and experienced drivers. We ensure that your Darshan trip to Alandi and Dehu is peaceful, comfortable, and hassle-free.',
        },
    ];
    
    const testimonials = [
        {
            name: "Mr. Rajesh Patil",
            position: "Pilgrim",
            text: "My trip to Alandi and Dehu with Mauli Cabs was peaceful and comfortable. The driver was courteous, and the car was clean and air-conditioned. I was able to visit both temples without any issues. Highly recommend Mauli Cabs for anyone traveling for Darshan!",
            image: "/img/testimonial/testimonial-thumb-1-1.png",
        },
        {
            name: "Miss. Sushma Rani",
            position: "Devotee",
            text: "Mauli Cabs made our trip to Alandi and Dehu smooth and comfortable. The driver was well-informed, and we had a great experience visiting both temples. The car was comfortable, and we had a pleasant journey. I will definitely book with them again for future Darshan trips!",
            image: "/img/testimonial/testimonial-thumb-1-2.png",
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    









    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7972733209",
            "+91 9763272775",

        ],
        email: "booking@maulicabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Car Rental",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Shirdi Cab Booking",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mahabaleshwar Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Lonavala - Khandala Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Mumbai Airport Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: " Pune to Adlabs Imagica Cab Booking ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Best Cab Service For Matheran",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Ganpatipule Cab Booking",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Pandharpur Cab Booking",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Pune to Jyotirlinga Tour Package",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Ashtavinayak Darshan Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Best Cab From Pune to Murud Janjira",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Pune to Alibaug Affordable Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Pune to Ajanta Ellora Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune to Aurangabad Cab Booking",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Pune to Sade Teen Shakti Peeth Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Pune to Bhimashankar Round Trip",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Pune Trimbakeshwar Best Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Nashik and Igatpuri Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Kolhapur Cab Booking",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Satara Cab Booking",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Tarkarli - Malvan Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune to Outstation Cab",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Goa Cab Booking",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune to Tuljapur Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Pune to Alandi - Dehu Darshan Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


    const jsonData = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Pune to Alandi - Dehu Darshan Cab Booking by Mauli Cabs",
        "description": "Mauli Cabs offers affordable and comfortable cab services from Pune to Alandi - Dehu Darshan. Choose from private, luxury, or group taxis for a one-way or round-trip journey. Enjoy a smooth and reliable ride for your pilgrimage tour to Alandi and Dehu with 24x7 online booking support.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.7",
          "ratingCount": "4100"
        }
      };
      
      
      


    return (
        <div>
            <GTag/>


<Helmet>
        <title>Pune to Alandi - Dehu Darshan Cab Booking | Mauli Cabs | Call +91 7972733209</title>
        <meta
          name="description"
          content="Book your Pune to Alandi - Dehu Darshan cab with Mauli Cabs. Choose from affordable, private, luxury, and group taxi options for one-way or round-trip travel. Enjoy a comfortable and reliable ride for your Alandi - Dehu pilgrimage tour with 24x7 online booking."
        />
        <meta
          name="keywords"
          content="Pune to Alandi - Dehu Darshan cab service, Book Pune to Alandi - Dehu Darshan taxi, Affordable Pune to Alandi - Dehu Darshan cab, Private taxi for Alandi - Dehu Darshan from Pune, Alandi - Dehu pilgrimage tour from Pune, Pune to Alandi - Dehu one-way or round trip, Comfortable taxi ride to Alandi - Dehu, Group travel to Alandi - Dehu, Luxury cab for Alandi - Dehu Darshan"
        />
        <script type="application/ld+json">
          {JSON.stringify(jsonData)}
        </script>
      </Helmet>

            <section
                className="vs-breadcrumb"
                style={{ backgroundImage: 'url(/img/bg/breadcrumb-bg-2.png)' }}
            >
                <div className="container">
                    <div className="row text-center">
                        <div className="col-12">
                            <div className="breadcrumb-content">
                                <h1 className="breadcrumb-title">{cardData.keyword}</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </section>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/26.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mauli Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #631D02',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#631D02' }}>
                                            <h4 className=" lead fw-semibold whitt textt-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917972733209" className="d-block  text-white">+91 7972733209</a>
                                                <a href="tel:+919763272775" className="d-block  text-white">+91 9763272775</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Email</h4>
                                                <a href="mailto:booking@maulicabs.com" className=" text-white d-block">
                                                    booking@maulicabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Mauli Cabs <br />
                                                    Pune Alandi Road , Wadmukkhwadi Charholi Bk, Alandi Devachi , Khed , Pune 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetoalandidehu;